import React from 'react'
import { useHistory } from 'react-router'
import { Messages2 } from 'iconsax-react'
import { useTheme } from '@mui/material'

import { ReminderItemProps } from '..'
import { Routes } from '@SonarCX/Routes'
import { useSocket } from '@SonarCX/providers/SocketProvider'
import { useUserAPI } from '@SonarCX/providers/UserAPIProvider'
import { useAppSelector } from '@SonarCX/hooks/redux'
import { useEnvironment } from '@SonarCX/providers/EnvironmentProvider'
import { selectConvo } from '@SonarCX/slices/convo'

import Tooltip from '@SonarCX/components/atoms/Tooltip'

import useStyles from '../styles'

const ReminderSession: React.FC<ReminderItemProps> = ({ object_id }) => {
  const theme = useTheme()
  const classes = useStyles()
  const history = useHistory()
  const { allConversations } = useAppSelector(selectConvo)
  const { user: currentUser } = useEnvironment()
  const {
    api: { fetchTimeline }
  } = useSocket()
  const { allUsers, loaded: usersLoaded, loaded: userLoading } = useUserAPI()
  const fullSession = React.useMemo(
    () => allConversations[object_id] ?? null,
    [allConversations, object_id]
  )

  // Comma separated list of user names
  const convoName = React.useMemo(() => {
    if (!fullSession) return ''

    if (fullSession.name) {
      return fullSession.name
    }

    const names = []
    fullSession.userIds
      .filter(id => id !== currentUser?.id)
      .forEach(id => {
        const user = allUsers[id]
        if (user) {
          names.push(user.name)
        }
      })
    return names.join(', ')
  }, [fullSession, currentUser, allUsers])

  const navigate = () => {
    history.replace(`${Routes.CLIENT_CHATS}?session=${object_id}`)
  }
  // Gets the full timeline
  React.useEffect(() => {
    if (fullSession || !usersLoaded || userLoading) {
      return
    }
    fetchTimeline(object_id, false, false)
  }, [
    allUsers,
    object_id,
    fetchTimeline,
    fullSession,
    userLoading,
    usersLoaded
  ])

  if (!fullSession) return null

  return (
    <div className={classes.root} onClick={navigate}>
      <span className={classes.info}>
        <Tooltip title='Conversation'>
          <Messages2
            size={theme.size.base}
            variant='Bulk'
            color={theme.palette.primary.main}
          />
        </Tooltip>
        <span className={classes.title}> {convoName}</span>
      </span>
    </div>
  )
}

export default ReminderSession
